import types from './filters/types'
import causes from './filters/causes'
import subjects from './filters/subjects'

export default {
    data: {
        getIssueOptions: {
            types,
            causes,
            subjects,
        },
    },
}
